// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_401fbf5","cardWrapper":"_8dd346a","card":"_1ef8966","widgetRow":"_9c8965c","widgetHeaderRow":"_ee41e43"};